













import { Component, Mixins, Prop, } from "vue-property-decorator";
import { StandardOption } from "../../../../system/selectors/mixins";
import { DrawableItemEditorMixin } from "../../mixins";
import { PropertyEditableMixin, LineDrawerPropertyEditableMixin } from "../../propertyEditors/mixins";
import SignStyleEditor from "./SignStyleEditor.vue";

@Component({
  components: {
    SignStyleEditor,
  },
})
export default class SignPropertyEditor extends Mixins(
  PropertyEditableMixin,
  DrawableItemEditorMixin,
  LineDrawerPropertyEditableMixin) {
  @Prop()
  options: StandardOption<any>[];
}
